import { SkeletonLoader as Loader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cl from './skeleton-loader.module.scss'

export const SkeletonLoader = () => {
	return (
		<div className={cl.content}>
			<div>
				<Loader height={36} borderRadius={14} style={{ marginBottom: 20, width: 200 }} />
				<div style={{ display: `flex`, justifyContent: 'space-between', alignItems: 'center' }}>
					<div style={{ display: `flex`, gap: 10 }}>
						<Loader height={40} borderRadius={14} style={{ width: 144 }} />
						<Loader height={40} borderRadius={14} style={{ width: 144 }} />
					</div>
					<Loader height={20} borderRadius={14} style={{ width: 144 }} />
				</div>
			</div>
			<div />
			<div>
				<Loader height={620} borderRadius={14} style={{ marginBottom: 10 }} />
				<Loader height={620} borderRadius={14} />
			</div>
			<div className={cl.sidebar}>
				<Loader height={350} borderRadius={14} />
				<Loader height={58} borderRadius={14} />
				<Loader height={105} borderRadius={14} />
			</div>
		</div>
	)
}
